import React, { useState, useRef, useEffect } from 'react';
import DownloadImg from './DownloadImg';
import CsvViewer from './CsvViewer';
import './ShowImg.css'

export default function ShowImg({fig_list}) {
  console.log("Figlist", fig_list)
  const image_list = fig_list || [];
  const [preview, setPreview] = useState(null);
  const openPreview = (img) => {
    if (!img.imgurl) return;
    setPreview({
      imgurl: img.imgurl,
      title: img.title
    });
  };
  const validImages = image_list.filter(
    img =>
      img.id === "table" ||
      img.imgurl ||
      img.csvurl
  );
  console.log("VALID", validImages);


  const closePreview = () => setPreview(null);

  useEffect(()=>{
    const onKeyDown = (e)=>{
      if (e.key === "Escape") closePreview();
    };

    if (preview)
      window.addEventListener("keydown", onKeyDown);

    return ()=> window.removeEventListener("keydown", onKeyDown);

  }, [preview]);


  return(
  <>
  <div className="image-grid">
    {validImages.map((img) => {

      if (img.id === "table") {

        return (
          <div key={img.id} className="table-card">

            <div className="table-card-header">
                {img.title}
            </div>

            <CsvViewer base64Data={img.csvurl} />

          </div>
        )
      }

      return (
        <div key={img.id} className="image-card">

          {img.imgurl && (
            <>
              <img
                src={img.imgurl}
                alt={img.title}
                onClick={()=> openPreview(img)}
              />

              <div className="download-btn-wrap">
                <DownloadImg
                  imgdata={img.imgurl}
                  filename={img.title}
                />
              </div>
            </>
          )}

          <p>{img.title}</p>

          {img.csvurl &&
            <CsvViewer base64Data={img.csvurl} />
          }

        </div>
      )

    })}

  </div>


  {preview && (
    <div
      className='img-modal'
      onClick={closePreview}
      role="dialog"
      aria-modal="true"
    >
      <div
        className='img-modal-content'
        onClick={(e)=>e.stopPropagation()}
      >
        <button
          className='img-modal-close'
          onClick={closePreview}
        >
          x
        </button>

        <img
          className='img-modal-img'
          src={preview.imgurl}
          alt={preview.title}
        />

      </div>
    </div>
  )}

  </>
  )

}